// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5":"ead27f4832845416","794":"eaab77a7f6753fa8","1933":"b058da1cc3d1855b","8386":"0771480d7fccec29"}[chunkId] + ".css";
};